import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/authContext'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'

function AuthHeaderLogin({ tabIndex }) {
  const { bootstrap } = useContext(AuthContext)
  const { t } = useTranslation()

  return (
    <div tabIndex={tabIndex} className={styles.headerActionsLogin} data-testid="header-login">
      <button className={styles.link} onClick={() => bootstrap.start({ signinRedirect: true })}>
        {t('header.menu.general.myAccount')}
      </button>
    </div>
  )
}

export default AuthHeaderLogin
